module.exports = __webpack_public_path__ + "static/neuehassunica-bold-abb0687a4aff51b6e5f0171301abaaac.woff2";